<template>
  <div class="content-root">
    <router-view></router-view>
  </div>
</template>

<script>
/**
 * @file       Layout site content component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "SiteContent"
};
</script>
